// Blog Tool - Content platform for guides, articles, and tool-specific resources
import { m } from "@/paraglide/messages";
import type { Tool } from "../index";

export const blogTool: Tool = {
  id: "blog",
  name: () => m.tool_blog_name(),
  description: () => m.tool_blog_description(),
  icon: "📝",
  basePath: "/blog",
  status: "stable",
  tags: ["articles", "guides", "content"],
};
